import AHSRequestService from '../services/apiRequests/ahs-requests.service';
import { usersService } from '../services/apiRequests/users.service';

export default {
    namespaced: true,
    state: {
        requestTypes: []
    },
    getters: {},
    mutations: {
        setRequestTypes(state, types) {
            state.requestTypes = types;
        }
    },
    actions: {
        async getRequestTypes({ commit }) {
            try {
                let response = await AHSRequestService.getAHSRequestTypes();
                commit('setRequestTypes', response);
            } catch (error) {
                //console.log(error);
            }
        },

        async createAHSRequest({ _state }, payload) {
            const requestData = {
                request_type_rid: payload.request_type_rid,
                contact_person: payload.contact_person,
                contact_number: payload.contact_number,
                object_contracts: payload.object_contracts, // null for KSK
                ksk_houses: payload.ksk_houses, // null for entity
                consumer_comment: payload.consumer_comment
            };

            let response = await AHSRequestService.createAHSRequest(requestData);
            return response.ahs_request[0];
        },

        async updateAHSRequest({ _state }, payload) {
            const requestData = {
                record_id: payload.record_id,
                request_type_rid: payload.request_type_rid,
                contact_person: payload.contact_person,
                contact_number: payload.contact_number,
                object_contracts: payload.object_contracts,
                ahs_documents: payload.ahs_documents,
                consumer_comment: payload.consumer_comment,
                alts_comment: payload.alts_comment
            };

            let response = await AHSRequestService.updateAHSRequest(requestData);
            return response.ahs_request[0];
        }
    }
};
